import classnames from "classnames";
import { selectCurrentRouteClusterId, selectRoute, } from "data/selectors/routes";
import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router5";
import * as analytics from "util/segment";
import "./internal-link.scss";
class InternalLink extends React.Component {
    constructor() {
        super(...arguments);
        this.successCallback = () => {
            const { route, routeInfo: { name }, category, } = this.props;
            if (!route) {
                return;
            }
            if (category) {
                analytics.trackInternalLinkClick(category, { url: name });
            }
        };
    }
    render() {
        // We hold on to `dispatch` and `category` so as not to pass it to `...rest`.
        const { routeInfo: { name, params }, className, clusterLink, currentClusterId, children, underlineOnHover, 
        // eslint-disable-next-line unused-imports/no-unused-vars
        dispatch, 
        // eslint-disable-next-line unused-imports/no-unused-vars
        category, ...rest } = this.props;
        let routeParams = params;
        if (clusterLink && params) {
            routeParams = {
                ...params,
                clusterId: currentClusterId,
            };
        }
        const classes = classnames("components-internal-link", className, {
            "no-underline": !underlineOnHover,
        });
        return (React.createElement(Link, { routeName: name, routeParams: routeParams, className: classes, successCallback: this.successCallback, ...rest }, children));
    }
}
InternalLink.defaultProps = {
    underlineOnHover: true,
};
export default connect((s) => {
    return {
        currentClusterId: selectCurrentRouteClusterId(s),
        route: selectRoute(s),
    };
})(withRouter(InternalLink));
